import { DataCell, DataColumn, DataRow } from "../types";
import * as XLSX from "xlsx";

export class ExcelWorkSheetBuilder {

    public cellStyle: boolean = true;
    public raw: boolean = true;

    private columns: DataColumn[] = [];
    private headers: DataRow[] = [];
    private rows: DataRow[] = [];

    public addColumn(column: DataColumn) {
        this.columns.push(column);
    }

    public addColumns(columns: DataColumn[]) {
        columns.forEach(column => {
            this.columns.push(column);
        })
    }

    public addHeader(headerRow: DataRow) {
        this.headers.push(headerRow);
    }

    public addRow(dataRow: DataRow) {
        this.rows.push(dataRow);
    }

    public build(): XLSX.WorkSheet {
        const htmlTableDOM = document.createElement('table');
        htmlTableDOM.innerHTML = this.createHtmlTable();

        const visibleColumnWidths = this.columns.filter(column => column.show).map(column => column.width);
        const worksheet = this.buildFromHtml(htmlTableDOM, visibleColumnWidths);
        return worksheet;
    }

    public buildFromHtml(htmlTable: HTMLTableElement, columnWidths: number[]): XLSX.WorkSheet {
        let worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(htmlTable, { raw: this.raw, cellStyles: this.cellStyle });

        worksheet["!cols"] = [];

        columnWidths.forEach(width => {
            worksheet["!cols"].push({ wpx: width })
        });

        return worksheet
    }

    private createHtmlHeader(): string {
        let headerHtml: string = "";

        if (this.headers.length > 0) {
            headerHtml += "<thead>"

            this.headers.forEach(headerRow => {
                headerHtml += "<tr>"
                headerRow.cells.forEach(cell => {
                    const cellHtml = this.createHtmlCell(cell);
                    headerHtml += cellHtml;
                })
                headerHtml += "</tr>"
            });

            headerHtml += "</thead>"
        }

        return headerHtml;
    }

    private createHtmlCell(cell: DataCell): string {
        let t = cell.type ? `t=${cell.type}` : "";
        let z = cell.format ? `z=${cell.format}` : "";
        const cellHtml = `<td ${t} ${z}>${cell.value}</td>`
        return cellHtml;
    }

    private createHtmlColumns(): string {
        let columnsHtml: string = "";

        if (this.headers.length > 0) {
            columnsHtml += "<tr></tr>"
        }

        columnsHtml += "<tr>"

        this.columns.forEach(column => {
            if (column.show) {
                const html = `<th>${column.value}</th>`
                columnsHtml += html;
            }
        });

        columnsHtml += "</tr>"

        return columnsHtml;
    }

    private createHtmlRows(): string {
        let rowsHtml: string = "";

        this.rows.forEach(row => {
            rowsHtml += "<tr>"
            for (let index = 0; index < row.cells.length; index++) {
                const column = this.columns[index]
                const cell = row.cells[index];

                if (column.show) {
                    const cellHtml = this.createHtmlCell(cell);
                    rowsHtml += cellHtml;
                }
            }
            rowsHtml += "</tr>"
        })

        return rowsHtml;

    }

    private createHtmlTable(): string {
        let htmlTable: string;
        htmlTable += this.createHtmlHeader();
        htmlTable += "<tbody>";
        htmlTable += this.createHtmlColumns();
        htmlTable += this.createHtmlRows();
        htmlTable += "</tbody>";
        return htmlTable;
    }

}
